// Семантические статус-токены кабинета — единый источник цвета для бейджей и статус-иконок.
// Опираются на фирменную триаду brand/lime/wheat (+ red — опасность, gray — нейтральное).
// Значения — имена цветов темы Mantine (используются с variant="light"). Меняем смысл ЗДЕСЬ —
// перекрашивается весь кабинет разом. См. design-guidelines → «Бренд и тема».
export const STATUS = {
  /** в процессе · активно · в сделке · текущий шаг · основной счёт */
  active: 'brand',
  /** завершено · подписано · аттестовано · успех */
  done: 'lime',
  /** ожидание · требует внимания · на модерации · скоро */
  waiting: 'wheat',
  /** отмена · ошибка · неверная подпись */
  danger: 'red',
  /** черновик · пауза · неизвестно */
  neutral: 'gray',
} as const;

export type StatusToken = keyof typeof STATUS;
